//TODO: see how this can be combined with the better config files in the /config directory and/or the config service

export default {
    LEGACY_PARTIMAGE_BASE: "https://images.qgistix.com/images/qgistix/",
    QBOS: "https://apix.qgistix.com/qbos/",
    QUS: "https://api.qgistix.com/qus/",
    QDS: "https://api.qgistix.com/qds/",
    QIS: "https://api.qgistix.com/qis/",
    QSS: "https://api.qgistix.com/qss/",
    QATS: "https://api.qgistix.com/qats/",
    QLPS: "https://api.qgistix.com/qlps/",
    QOps: "https://api.qgistix.com/qops/",
    QR2DC: "https://api.qgistix.com/qr2dc/",
    poolData: { UserPoolId: "us-west-2_nojsUGoWd", ClientId: "428evbdpi7qlo4ub7r4b9quu13" },
}
